import FileUploadIcon from "@mui/icons-material/FileUpload";
import ImportEdition from "./Create";

//params
export const EDITIONS_IMPORT = "editions-import";
//permissions

export const resources = {
  isMenu: true,
  icon: <FileUploadIcon />,
  name: EDITIONS_IMPORT,
  title: "Импорт на кампания",
  list: <ImportEdition />,
  permission: "editions",
};

//api url
